'use strict';

const $ = require('jquery');

class General {

    constructor() {

        //  Load Foundation
        require('./../../../../build/node_modules/@components/foundation-sites/dist/js/foundation.js');
        App.Globals.$document.foundation();

        //  SVG Inline
        const inlineSVG = require('./../../../../build/node_modules/@components/inline-svg/src/inlineSVG.js');
        inlineSVG.init({
            svgSelector: 'img.svg',
            initClass: 'js-inlinesvg'
        });

        //  Make link a button
        let $link = $('.make-link-button');

        if ($link.length > 0) {

            $link.each(function () {

                let $button = $(this);
                let buttonHtml = $button.html();

                $button
                    .addClass('button primary')
                    .removeClass('make-link-button')
                    .html(`<span>${buttonHtml}</span>`);
            });
        }
    }
}

module.exports = General;
